import { render, staticRenderFns } from "./ComprometimentoAprovacao.vue?vue&type=template&id=1b3fe252&"
import script from "./ComprometimentoAprovacao.vue?vue&type=script&lang=js&"
export * from "./ComprometimentoAprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports